import { FC } from 'react';
import styles from './sidebar-logo.module.css';
import logo from '../../../logo.png';

export const SidebarLogo: FC = () => {
  return (
    <div className={styles.sidebar_logo}>
      <img className={styles.sidebar_logo__icon} src={logo} alt="resurs"></img>
      <div className={styles.sidebar_logo__title} id="sidebar_label">
        АРМ Ресурс
      </div>
    </div>
  );
};
